<template>
  <div>
    <h2>Joke of the day!</h2>
    <p>{{question}}</p>
    <p>{{answer}}</p>
  </div>
</template>

<script>
export default {
  name: 'joke',
  props: [
    'question',
    'answer'
  ]
}
</script>
